import { MONTHS_FR_SHORT, MONTHS_FR_LONG } from './locale';

export const RECURRENCE_KINDS = {
  monthly: {
    label: 'Mensuel',
    color: '#a5b4fc',
    bg: 'rgba(165,180,252,0.10)',
    border: 'rgba(165,180,252,0.28)',
  },
  quarterly: {
    label: 'Trimestriel',
    color: '#fbbf24',
    bg: 'rgba(251,191,36,0.10)',
    border: 'rgba(251,191,36,0.28)',
  },
  yearly: {
    label: 'Annuel',
    color: '#c084fc',
    bg: 'rgba(192,132,252,0.10)',
    border: 'rgba(192,132,252,0.28)',
  },
  custom: {
    label: 'Personnalisé',
    color: '#5eead4',
    bg: 'rgba(94,234,212,0.10)',
    border: 'rgba(94,234,212,0.28)',
  },
};

export function getRecurrenceKind(rp) {
  const key = rp?.type || 'monthly';
  return RECURRENCE_KINDS[key] ? key : 'monthly';
}

export function getActiveMonths(rp) {
  const kind = rp?.type || 'monthly';
  if (kind === 'monthly') return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  if (kind === 'quarterly') {
    const ms = rp?.months;
    return ms && ms.length
      ? [...new Set(ms)].sort((a, b) => a - b)
      : [0, 3, 6, 9];
  }
  if (kind === 'yearly') return rp?.month != null ? [rp.month] : [];
  if (kind === 'custom') {
    const ms = rp?.customMonths;
    return ms && ms.length ? [...new Set(ms)].sort((a, b) => a - b) : [];
  }
  return [];
}

function monthsInitials(indices) {
  return [...(indices || [])]
    .filter((i) => i >= 0 && i < 12)
    .sort((a, b) => a - b)
    .map((i) => MONTHS_FR_SHORT[i])
    .join(' · ');
}

export function fmtRecurrenceShort(rp) {
  if (!rp) return 'Mensuel';
  switch (rp.type) {
    case 'monthly':
      return 'Tous les mois';
    case 'quarterly': {
      const months = rp.months?.length ? rp.months : [0, 3, 6, 9];
      return `Trimestriel · ${monthsInitials(months)}`;
    }
    case 'yearly':
      return rp.month != null ? `Annuel · ${MONTHS_FR_LONG[rp.month]}` : 'Annuel';
    case 'custom':
      if (rp.customMonths?.length === 12) return 'Tous les mois';
      if (rp.customMonths?.length) {
        return `${rp.customMonths.length} mois / an · ${monthsInitials(rp.customMonths)}`;
      }
      return 'Personnalisé';
    default:
      return 'Mensuel';
  }
}

export function templateId(tpl) {
  return tpl._id || tpl.id;
}

export function isInValidityPeriod(validityPeriod, month, year) {
  const vp = validityPeriod || {};
  if (vp.startDate) {
    const s = new Date(vp.startDate);
    if (year < s.getFullYear()) return false;
    if (year === s.getFullYear() && month < s.getMonth()) return false;
  }
  if (vp.endDate) {
    const e = new Date(vp.endDate);
    if (year > e.getFullYear()) return false;
    if (year === e.getFullYear() && month > e.getMonth()) return false;
  }
  return true;
}

export function isTemplateValidForMonth(template, month, year) {
  if (!isInValidityPeriod(template.validityPeriod, month, year)) return false;
  return getActiveMonths(template.recurrencePattern).includes(month);
}

export function roundCents(num) {
  return Math.round((Number(num) + Number.EPSILON) * 100) / 100;
}
